import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon, GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/volumes';
const plan = {
  name: '📘 THE AI BOOK BUILDER™',
  ideal: 'Ideal for: Aspiring authors, first-time writers, self-published authors and anyone who wants to use AI to build a book with a structured process.',
  was: '$54',
  now: '27',
  features: ['Full 6-Volume AI Author System', '100+ Ready-to-use AI Prompts', 'Works with major AI models', '4 Professional Bonuses Included', '7-Day Risk-Free Guarantee', 'Lifetime Access & Free Updates'],
  cta: 'Get the AI Book Builder™ now'
};
const trust = [{
  icon: LockIcon,
  label: 'Secure Checkout'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Digital & Mobile Access'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-129" data-mp="3vzynqjgdld45">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "0px",
      paddingBottom: "15px"
    }} data-id="element-130" data-mp="4s4ab7stylgb">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-131" data-mp="9tju6wj9ulx4">
          
          
          
          
          
          
          <p className="mt-5 inline-flex rounded-full border border-gold/60 bg-blush-soft px-4 py-1.5 text-xs font-bold text-blush-deep" data-id="element-132" data-mp="ep8y1c2bqoz8">
            🔥 Limited offer — ending soon
          </p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-133" data-mp="3i8bs8lu9c8mf">
            Don’t wait until another month passes with your manuscript unfinished.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border-2 border-gold bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(21,128,61,0.5)]" data-id="element-134" data-mp="3ryn4qws0bq4x">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] border-b-2 border-gold bg-grape-deep px-6 py-3" data-id="element-135" data-mp="2mfp5zcwak32m">
            <h3 className="font-display text-base font-black text-white" data-id="element-136" data-mp="318ikow3qof68">{plan.name}</h3>
          </div>
          <p className="text-sm font-semibold text-plum/70" style={{
          fontSize: "12px"
        }} data-id="element-137" data-mp="2w9xnl5jsabm0">{plan.ideal}</p>

          <div className="mt-6" data-id="element-138" data-mp="23j5tcdma3x1b">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-139" data-mp="23k7ghggkk9ze">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-140" data-mp="2ih80sywfl2nu">
              <span className="relative inline-block font-display leading-none" data-id="element-141" data-mp="2dhd7kop6o0zm">
                <span className="absolute right-full top-1/2 mr-1 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-142" data-mp="2djg6jy8bd4gh">
                  $
                </span>
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-143" data-mp="9c8chihwyz6">
                  {plan.now}
                </span>
                <span className="absolute bottom-2 left-full ml-1.5 text-sm font-black text-plum/60" style={{
                fontSize: "18px"
              }} data-id="element-144" data-mp="3ng4rzruw86sf">USD</span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-145" data-mp="j1wpj1ou1fn5">
              · One-time payment · Lifetime Access ·
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-146" data-mp="o22gefna2y46">
              Payment will be processed in your local currency.
            </p>
          </div>

          
          <ul className="mt-3 w-full flex-1 space-y-3 text-left" data-id="element-147" data-mp="e8byxupkjnxz">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-148" data-mp="11y6beb5z7ahp">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-149" data-mp="16r93eev3ubvs" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-150" data-mp="3a8fdyixsfidy">
            <CTAButton size="md" data-id="element-151" data-mp="3a6ujsufdy1gm">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-blush" data-id="element-152" data-mp="358komjtnv0v0">
            Start building your book → Save $27 (-50%)
          </p>

          <p className="mt-5 text-[11px] font-black uppercase tracking-wider text-plum/60" data-id="element-153" data-mp="319bxlmq09h35">100% secure payment</p>
          <div className="mt-2 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-154" data-mp="1uq9j9biec89">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-155" data-mp="3o6dr5l0dh8rv">
                <Icon className="h-4 w-4 text-grape" data-id="element-156" data-mp="3k5tu0hfsu55q" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 w-full max-w-2xl rounded-2xl border-2 border-grape bg-white p-6 text-center" data-id="element-157" data-mp="kl81hboip3sk">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-grape" strokeWidth={1.75} aria-hidden="true" data-id="element-158" data-mp="1yf50wcjiejzj" />
          <h3 className="mt-2 font-display text-xl font-black text-grape-deep sm:text-2xl" data-id="element-159" data-mp="23dycfzf8k0x2">
            🛡️ 7-Day Money-Back Guarantee
          </h3>
          <p className="mx-auto mt-3 max-w-lg text-[15px] leading-relaxed text-plum/75" data-id="element-160" data-mp="27e9yngn8y9an">
            Try THE AI BOOK BUILDER™ for 7 days. Explore the system. Test the prompts. Use them with your book idea or
            manuscript. If you decide that the system isn’t right for you, you can request a refund within the applicable
            7-day period.
          </p>
          <p className="mt-3 text-sm font-bold text-plum" data-id="element-161" data-mp="2r3kcsq7cgm6n">No complicated process. No long-term commitment.</p>
          <p className="mt-3 border-t border-gold/30 pt-3 text-xs font-semibold italic text-blush" data-id="element-162" data-mp="2v4cmfkk4ot3g">
            SIGMA SMART™ is committed to delivering a practical, useful AI-assisted author system.
          </p>
        </div>
      </div>
    </section>;
}